import { IMG_V3kY03h94bAJ9S1CzXHIG } from '@ecomm/contentful-media'
import { useTranslation } from '@ecomm/i18n'
import { AlarmMomentsTab } from '@ecomm/shared-components/v2/lib/AlarmMoments/AlarmMomentsTab'

export function TabBreakIn() {
  const { t } = useTranslation('alarm-moments')
  const details = [
    {
      icon: 'Siren',
      text: t('detail.break-in-siren')
    },
    {
      icon: 'PhoneRinging',
      text: t('detail.break-in-app-notification')
    },
    {
      icon: 'HeadsetPerson',
      text: t('detail.break-in-agent-interaction')
    },
    {
      icon: 'PoliceCar',
      text: t('detail.break-in-police-dispatch')
    },
    {
      icon: 'HeadsetPerson',
      text: t('detail.break-in-agent-update')
    }
  ] as const
  const disclaimers = [
    t('disclaimer.active-guard-required'),
    t('disclaimer.break-in-agent-interaction'),
    t('disclaimer.break-in-police-dispatch')
  ] as const
  return (
    <AlarmMomentsTab
      image={IMG_V3kY03h94bAJ9S1CzXHIG}
      details={details}
      disclaimers={disclaimers}
    />
  )
}
